import {ImageOpInputsOrNodes, EvaluatedImageOpParameters} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/brush-strokes/definition"
import {ImageOpBrushStrokeHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/brush-strokes/hal"
import {ImageOpContextHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-hal"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ComplexSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/complex-specializing-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeBrushStroke"}

@registerImageOpNode
export class ImageOpNodeBrushStrokes extends ComplexSpecializingImageOpNode<typeof definition, ImageOpBrushStrokeHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(parameters)
    }

    protected async createImageOpHal(
        evaluator: Evaluator<ImageOpContextHal>,
        parameters: EvaluatedImageOpParameters<ImageOpParametersOfType<typeof definition, "hal">>,
    ) {
        return new ImageOpBrushStrokeHal(evaluator.context, parameters)
    }

    protected async updateImageOpHal(
        evaluator: Evaluator<ImageOpContextHal>,
        imageOpHal: ImageOpBrushStrokeHal,
        parameters: EvaluatedImageOpParameters<ImageOpParametersOfType<typeof definition, "hal">>,
    ) {
        imageOpHal.setParameters(parameters)
    }

    protected getHalResult(
        _evaluator: Evaluator<ImageOpContextHal>,
        imageOpHal: ImageOpBrushStrokeHal,
        _parameters: EvaluatedImageOpParameters<ImageOpParametersOfType<typeof definition, "hal">>,
    ) {
        return {
            resultImage: imageOpHal,
            boundingBox: {
                ...imageOpHal.data.getBoundingBox(), // make sure we return a copy of the bounding box to avoid mutation issues
            },
        }
    }
}
